import { render, staticRenderFns } from "./SourceSearch.vue?vue&type=template&id=c4304ebe&scoped=true&"
import script from "./SourceSearch.vue?vue&type=script&lang=ts&"
export * from "./SourceSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SourceSearch.vue?vue&type=style&index=0&id=c4304ebe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4304ebe",
  null
  
)

export default component.exports